import React from 'react'
import {ImLocation} from 'react-icons/im';
import {FiPhoneOutgoing} from 'react-icons/fi';
import {SiMinutemailer} from 'react-icons/si';
// import {AiOutlineCheck} from 'react-icons/ai';
import {Link} from 'react-router-dom';

const Sidebar = () => {
    return (
        <>
            {/* <div className="ps-informations">
                <h3>Project Details</h3>
                <ul>
                    <li><span><i><AiOutlineCheck/></i>Category:</span> Machine</li>
                    <li><span><i><AiOutlineCheck/></i>Client:</span> Alex Brons</li>
                    <li><span><i><AiOutlineCheck/></i>Location:</span> New York, USA</li>
                    <li><span><i><AiOutlineCheck/></i>Budget:</span> $75,000</li>
                    <li><span><i><AiOutlineCheck/></i>Completed:</span> 28 June, 2019</li>
                </ul>
            </div>
            <div className="company-info">
                <h3>Our Company Brochure</h3>
                <p>We are a cutting-edge Data Analytics Company specializing in ETL, Data Engineering, Data Governance, Cloud Migration, AI, and ML.</p>
                <Link to="/#" className="btn btn-theme">Download PDF</Link>
            </div> */}
            <div className="contact-widget">
                <h3>Contact Us</h3>
                <ul>
                    <li>
                        <i> <ImLocation/></i> 12790 FM1560 N # 892, Helotes, TX 78023
                    </li>
                    <li>
                        <i><FiPhoneOutgoing/></i><Link to="/#">+1 (210) 996-2014</Link>
                    </li>
                    <li>
                        <i> <SiMinutemailer/> </i><Link to="/#">admin@primedatainsights.com</Link>
                    </li>
                </ul>
            </div>
        </>
    )
}

export default Sidebar
